import React, { useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { AuthContext } from 'context';
import { Formik, Form } from 'formik';
import { BusinessSuccess } from './steppers';
import { BusinessError } from './steppers/BusinessError';
import { createSchema } from './schema/Schema';
// Data
import InitialFormValues from './data/initalValues';
import { SidebarLayout } from 'layouts/Sidebar/SidebarLayout';
import { NavegacionFormulario } from 'components/design-system/NavegacionFormulario/NavegacionFormulario';
import { CircularProgress } from '@mui/material';
import { RUTAS } from 'const/Rutas';
// Services
import serviceEmpresas from 'services/empresas';
// Helpers
import { stepsIngresar, SwitchSteps, formatoServicio } from './helpers';

const NewBusiness = () => {
  const { refrescarSesion, token, isTienePermisos } = useContext(AuthContext);
  const history = useHistory();
  const [step, setStep] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [errorService, setErrorService] = useState(false);

  const onSiguientePaso = (validateForm, setFieldTouched) => {
    validateForm().then(resp => {
      const validaciones = Object.keys(resp);
      validaciones.forEach(campo => {
        setFieldTouched(campo, true);
      });

      if (validaciones.length !== 0) {
        return;
      }

      window.scrollTo(0, 0);
      setStep(paso => paso + 1);
    });
  };

  const onFinalizar = handleSubmit => {
    handleSubmit();
  };

  const handlePasoAnterior = () => {
    if (step === 0) history.push(RUTAS.HOME_USER);
    if (step > 0) {
      window.scrollTo(0, 0);
      setStep(step - 1);
    }
  };

  return (
    <SidebarLayout
      containerClassName="md:px-4 md:container md:mx-auto"
      childrenContainerClassName={'col-span-12 lg:col-span-10 pt-0 md:pt-10'}
    >
      <Formik
        initialValues={InitialFormValues}
        validationSchema={createSchema(isTienePermisos)[step]}
        validateOnChange={true}
        validateOnBlur={true}
        onSubmit={values => {
          try {
            setStep(6);
            const dataFormateada = formatoServicio(values);
            // console.log('dataFormateada', dataFormateada);
            serviceEmpresas
              .empresa(dataFormateada)
              .then(response => {
                refrescarSesion(token).finally(() => {
                  setStep(7);
                  setErrorService(false);
                });
                setIsLoading(false);
              })
              .catch(error => {
                setErrorService(true);
                setIsLoading(false);
              });
          } catch (error) {
            setErrorService(true);
            setIsLoading(false);
          }
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleReset,
          handleSubmit,
          setFieldValue,
          handleBlur,
          setErrors,
          setFieldError,
          setFieldTouched,
          isSubmitting,
          validateForm
        }) => (
          <Form
            onSubmit={event => {
              event.preventDefault();
            }}
          >
            {errorService ? (
              <BusinessError
                onReintentar={() => {
                  setStep(0);
                  setErrorService(false);
                }}
              />
            ) : (
              <>
                {step === 7 ? (
                  <BusinessSuccess values={values} isLoading={isLoading} />
                ) : (
                  <NavegacionFormulario
                    titulo="Registro de negocio"
                    pasos={stepsIngresar}
                    onCancelar={() => history.push(RUTAS.HOME_USER)}
                    onSiguiente={() =>
                      onSiguientePaso(validateForm, setFieldTouched)
                    }
                    onFinalizar={() => onFinalizar(handleSubmit)}
                    onVolver={() => handlePasoAnterior()}
                    pasoActual={step}
                    values={values}
                    isSubmitting={isSubmitting}
                  >
                    {isSubmitting ? (
                      <div className="h-80 flex justify-center items-center">
                        <CircularProgress
                          color="inherit"
                          size={80}
                          thickness={2}
                        />
                      </div>
                    ) : (
                      SwitchSteps({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleSubmit,
                        handleBlur,
                        setFieldValue,
                        setFieldTouched,
                        setFieldError,
                        handleReset,
                        step,
                        setStep,
                        errorService,
                        isSubmitting,
                        setErrors
                      })
                    )}
                  </NavegacionFormulario>
                )}
              </>
            )}
          </Form>
        )}
      </Formik>
    </SidebarLayout>
  );
};

export default NewBusiness;
